'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import { BLOCKS } from '@contentful/rich-text-types';

import Img from 'components/ui/Img';
import EntryLink from 'components/ui/Link/EntryLink';
import RichText from 'components/ui/RichText';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import useGeolocation from 'hooks/useGeolocation';

import styles from './BlockEventNearby.module.scss';

const richTextOverrides = {
    headline: {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => (
                <Text
                    as="p"
                    className={styles.headline}
                    baseTheme="headingXSmall2"
                    themes={{
                        medium: 'displayXXSmall',
                    }}
                >
                    {children}
                </Text>
            ),
        },
    },
    bodyCopy: {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => (
                <Text
                    as="p"
                    className={styles.copy}
                    baseTheme="bodyMedium"
                    themes={{
                        medium: 'bodyMedium',
                        large: 'bodyMediumLarge',
                    }}
                >
                    {children}
                </Text>
            ),
        },
    },
};

const BlockEventNearby = ({
    headline,
    regionCategory,
    regions,
    image,
    bodyCopy,
    backgroundColor,
    link,
}) => {
    const { geolocation } = useGeolocation();

    const matchRegion = (regionCategory, regions) => {
        const viewerCountry = geolocation?.viewerCountry || 'Unknown';
        const viewerCountryRegion =
            geolocation?.viewerCountryRegion || 'Unknown';

        // Map against nested regions object
        // Contentful goes crazy if this field is not an object
        const states = regions?.regions || [];

        // Check for required region category before proceeding
        if (!regionCategory) {
            console.warn(`Region category required for alert render.`);
            return false;
        }

        if (regionCategory === 'Global') {
            console.info('Global match', viewerCountry, viewerCountryRegion);
            return true;
        }

        if (regionCategory === 'Outside US' && viewerCountry !== 'US') {
            console.info(`Outside US`, viewerCountry, viewerCountryRegion);
            return true;
        }

        if (
            (regionCategory === 'US' ||
                regionCategory === 'Core' ||
                regionCategory === 'Growth' ||
                regionCategory === 'Frontier') &&
            viewerCountry === 'US'
        ) {
            const match = states.includes(viewerCountryRegion);

            if (match) {
                return match;
            }
        }

        // Nothing matches
        return false;
    };

    if (!matchRegion(regionCategory, regions)) {
        return null;
    }

    return (
        <div
            className={styles.root}
            style={{
                '--backgroundColor': backgroundColor || 'var(--colors-white)',
            }}
        >
            <EntryLink entry={link} className={styles.inner}>
                {image?.url && (
                    <Img
                        src={image.url}
                        width={image?.width}
                        height={image?.height}
                        alt={image.title}
                        className={styles.image}
                    />
                )}
                <div className={styles.content}>
                    <RichText
                        richText={headline}
                        className={styles.headline}
                        overrides={richTextOverrides.headline}
                    />
                    <RichText
                        richText={bodyCopy}
                        className={styles.copy}
                        overrides={richTextOverrides.bodyCopy}
                    />
                </div>
                <span className={styles.cta}>
                    <SvgIcon type="arrowRight" />
                </span>
            </EntryLink>
        </div>
    );
};

export default BlockEventNearby;
